<div class="sb-step sb-step-customer">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container sb-step__inner-container--small">
        <!-- region Marketing Consents -->
        <sb-consent-form
          (toggleConsentsEvent)="onToggleConsents()"
          [formGroup]="formGroup"
          [shouldShowAllConsents]="consentFormIsOpen"></sb-consent-form>
        <!-- endregion -->
      </div>
    </div>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid"
                             [showCloseButton]="consentFormIsOpen"
                             (closeClick)="onCloseConsents()" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()">
      </sb-navigation-buttons>
    </div>
  </form>
</div>
